// Sidebar.js
import React from 'react';
import styles from './Sidebar.module.css'; // Import Sidebar styles

const Sidebar = ({
  children,
  collapsible = false,
  collapsed = false,
  onToggle,
  edgeToggle = false,
}) => {
  return (
    <aside className={`${styles.sidebar} ${collapsed ? styles.collapsed : ''} ${edgeToggle ? styles.edgeToggle : ''}`}>
      {collapsible && (
        <button
          type="button"
          className={styles.collapseButton}
          onClick={onToggle}
          aria-expanded={!collapsed}
          aria-label={collapsed ? 'Expand side panel' : 'Collapse side panel'}
          title={collapsed ? 'Expand side panel' : 'Collapse side panel'}
        >
          {collapsed ? '‹' : '›'}
        </button>
      )}
      <div className={styles.sidebarContent} hidden={collapsed}>
        {children}
      </div>
    </aside>
  );
};

export default Sidebar;
